import _ from 'lodash';

export const getQueryString = (reqParams, allowedParams) => {
  const queryParams = _.pick(reqParams, allowedParams);
  const query = Object.keys(queryParams)
    .map(
      param =>
        encodeURIComponent(param) + '=' + encodeURIComponent(queryParams[param])
    )
    .join('&');
  return query ? `?${query}` : '';
};

export const getAllowedProperties = (resource, allowedProperties) => {
  return _.pick(resource, allowedProperties);
};
